import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import BackButton from '../../BackButton';

import DateFilterSwitcher from '../DateFilterSwitcher';

import FilterHeader from '../FilterHeader';

import styles from './DateFilterHeader.module.scss';

const DateFilterHeader = ({
  subtitle = null,
  renderContent = null,
  onClickBack = null,
  onClickSwitcher = null,
  isMonthsFilter = false
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      const paddingTop = parseInt(getComputedStyle(ref.current).paddingTop, 10);
      const style = document.createElement('style');
      style.innerHTML = `
        body {
          --date-filter-header-height: ${
            ref.current.scrollHeight - paddingTop
          }px;
        }`;
      ref.current.appendChild(style);
    }
  }, [ref, isMonthsFilter]);

  return (
    <div className={styles['date-filter-header']} ref={ref}>
      <div className={styles['date-filter-header__title']}>
        {onClickBack && (
          <BackButton
            onClick={onClickBack}
            dataTest="date-range-filter-back-button"
          />
        )}
        <FilterHeader
          title={trans('search.exposedfilters.dates.range.title')}
          subtitle={subtitle}
        />
      </div>
      {onClickSwitcher && (
        <DateFilterSwitcher
          isMonthsFilter={isMonthsFilter}
          onClick={onClickSwitcher}
        />
      )}
      {renderContent ? renderContent() : null}
    </div>
  );
};

DateFilterHeader.propTypes = {
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  renderContent: PropTypes.func,
  onClickBack: PropTypes.func,
  onClickSwitcher: PropTypes.func,
  isMonthsFilter: PropTypes.bool
};

export default DateFilterHeader;
